Namespace 'Settings.Views.Topics'

class Settings.Views.Topics.GoogleMyBusinessChannelView extends Settings.Views.Topics.ChannelView
  sourceClassName: 'Keepcon::GoogleMyBusinessSource'
  provider: 'google_my_business'
  channelClassName: 'Keepcon::GoogleMyBusinessChannel'
  sourceIcon: image_path('source_google_my_business.png')
